import defaultTo from 'lodash/defaultTo'
import Cookies from 'js-cookie'
import Locale from '@models/Locale/model'

export default class LocaleManager {
  constructor (options) {
    this.settings = Object.assign({
      defaultLocale: process.env.LOCALE_DEFAULT,
      cookieName: process.env.LOCALE_COOKIE,
      supportedLocales: ['en', 'ru']
    }, options)
  }

  getLocale () {
    const value = Cookies.get(this.settings.cookieName)
    const locale = defaultTo(
        this.settings.supportedLocales.includes(value) ? value : undefined,
        this.settings.defaultLocale
    )

    return new Locale({ locale })
  }
}



// WEBPACK FOOTER //
// ./src/services/LocaleManager/LocaleManager.js